export var SessionOccupancyStatus;
(function (SessionOccupancyStatus) {
    SessionOccupancyStatus["AVAILABLE"] = "AVAILABLE";
    SessionOccupancyStatus["WAITLIST_AVAILABLE"] = "WAITLIST_AVAILABLE";
    SessionOccupancyStatus["FULL"] = "FULL";
})(SessionOccupancyStatus || (SessionOccupancyStatus = {}));
//# sourceMappingURL=session.dto.js.map